import { Card, CardContent } from "@/components/ui/card";

interface BigNumberCardProps {
  value: number;
  currency?: string;
  label?: string;
}

export const BigNumberCard: React.FC<BigNumberCardProps> = ({
  value,
  currency = 'USD',
  label
}) => {
  return (
    <Card>
      <CardContent className="flex items-center justify-center py-8 md:py-12 px-2">
        <div className="text-center w-full min-w-0">
          <div className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight truncate">
            ${value.toFixed(2)}
          </div>
          {label && (
            <div className="text-xs md:text-sm text-muted-foreground mt-2 md:mt-3">
              {label}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
